import { useFormContext } from 'react-hook-form';
import { useFormItem } from './form-item-context';

type FormFieldState = {
  id: string;
  name: string;
  controlId: string;
  descriptionId: string;
  messageId: string;
  error: string | undefined;
};

export function useFormField(): FormFieldState {
  const { id, name } = useFormItem();
  const { getFieldState, formState } = useFormContext();
  const { error } = getFieldState(name, formState);
  return {
    id,
    name,
    controlId: `${id}-control`,
    descriptionId: `${id}-description`,
    messageId: `${id}-message`,
    error: error?.message,
  };
}
